import { Modal as AntModal } from "antd";
import { Typography, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function ShiftBufferDaysModal({ visible, onClose, onReview, shifts }) {
  return (
    <AntModal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={true}
      maskClosable={false}
      keyboard={false}
      bodyStyle={{
        textAlign: "center",
        padding: "32px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* Warning Icon */}
      <WarningAmberIcon sx={{ fontSize: 48, color: "#ff9800", mb: 1 }} />

      {/* Title */}
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Job Posting Disabled
      </Typography>

      {/* Description */}
      <p
        style={{
          fontSize: "1rem",
          lineHeight: 1.6,
          color: "#555",
          marginBottom: 8,
          textAlign: "left",
        }}
      >
        You currently have shifts from the past {shifts} that are pending
        approval.
      </p>

      <p
        style={{
          fontSize: "1rem",
          lineHeight: 1.6,
          color: "#555",
          marginBottom: 24,
          textAlign: "left",
        }}
      >
        Please provide approval on shifts for that period to continue posting
        jobs.
      </p>

      {/* Action Button */}
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#0057ff",
          textTransform: "none",
          fontWeight: "500",
          px: 4,
          "&:hover": { backgroundColor: "#0046cc" },
          marginTop: "16px",
          width: "100%",
          borderRadius: "8px",
          fontWeight: "bold",
        }}
        // onClick={onReview}
        onClick={onReview}
      >
        Review Shifts
      </Button>
    </AntModal>
  );
}
